export default __webpack_public_path__ + "static/media/2.818e851c.jpg";